import React from 'react'
import {
   DataGrid,
   DataGridBody,
   DataGridCell,
   DataGridHeader,
   DataGridHeaderCell,
   DataGridRow,
   makeStyles,
   mergeClasses,
   TableColumnDefinition,
   tokens,
} from '@fluentui/react-components'

const useStyles = makeStyles({
   row: {
      cursor: 'pointer',
      '& > div': {
         flex: '0 1 auto',
      },
   },
   semibold: { '& > *': { fontWeight: tokens.fontWeightSemibold } },
   stickyHeader: {
      position: 'sticky',
      top: 0,
      zIndex: 2,
   },
   dataGrid: {
      height: '100%',
      overflowY: 'auto',
   },
})
type ListProps<T extends {}> = {
   columns: TableColumnDefinition<T>[]
   items: T[]
   onRowClick?: (item: T) => void
   title?: string
   rowClassName: string
   bodyClassName?: string
   className?: string
   beigeHeaderBackground?: boolean
}
export const CustomList = <T extends {}>({ columns, items, onRowClick, rowClassName,bodyClassName, className, beigeHeaderBackground }: ListProps<T>) => {
   const classes = useStyles()
   return (
      <DataGrid items={items} columns={columns} sortable className={mergeClasses(classes.dataGrid, className ?? '')}>
         <DataGridHeader
            className={classes.stickyHeader}
            style={{ backgroundColor: beigeHeaderBackground ? tokens.colorPaletteMarigoldBackground1 : tokens.colorNeutralBackground4 }}
         >
            <DataGridRow className={mergeClasses(classes.semibold, classes.row, rowClassName)}>
               {({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}
            </DataGridRow>
         </DataGridHeader>
         <DataGridBody<T> className={bodyClassName ? bodyClassName : ''}>
            {({ item, rowId }) => (
               <DataGridRow<T> onClick={() => onRowClick && onRowClick(item)} className={mergeClasses(classes.row, rowClassName)} key={rowId}>
                  {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
               </DataGridRow>
            )}
         </DataGridBody>
      </DataGrid>
   )
}
